module.exports = __webpack_public_path__ + "media/images/icons/interaktivniMapa-332467f6c47bff662bd5c08132be9ad8.svg";